/* ============================================
   MĀRYVO PROJECT — Shopify Theme JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  // --- Sticky header scroll effect ---
  const header = document.querySelector('[data-header]');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.scrollY;
      header.classList.toggle('scrolled', currentScroll > 50);
      lastScroll = currentScroll;
    }, { passive: true });
  }

  // --- Mobile menu toggle ---
  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-nav]');
  if (nav) {
      document.querySelectorAll('[data-mobile-toggle]').forEach(btn => {
        btn.addEventListener('click', () => {
          nav.classList.toggle('mobile-open');
          document.body.style.overflow = nav.classList.contains('mobile-open') ? 'hidden' : '';
        });
    });
  }

  // --- Cart drawer ---
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartBackdrop = document.querySelector('[data-cart-backdrop]');
  const cartClose = document.querySelector('[data-cart-close]');

  function openCart(e) {
    if (e) e.preventDefault();
    cartDrawer && cartDrawer.classList.add('open');
    cartBackdrop && cartBackdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('open');
    cartBackdrop && cartBackdrop.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);

  // --- Quantity selectors ---
  document.querySelectorAll('[data-quantity-minus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('[data-quantity-input], input[type="number"]');
      if (input && parseInt(input.value) > 1) {
        input.value = parseInt(input.value) - 1;
        input.dispatchEvent(new Event('change'));
      }
    });
  });

  document.querySelectorAll('[data-quantity-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('[data-quantity-input], input[type="number"]');
      if (input) {
        const max = input.getAttribute('max') ? parseInt(input.getAttribute('max'), 10) : Infinity;
        const v = parseInt(input.value) || 0;
        if (v < max) {
          input.value = v + 1;
          input.dispatchEvent(new Event('change'));
        }
      }
    });
  });

  // --- Product accordion ---
  document.querySelectorAll('[data-accordion-trigger]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.product-accordion__item');
      if (item) item.classList.toggle('open');
    });
  });

  // --- Product gallery thumbnails (desktop) ---
  document.querySelectorAll('[data-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const index = thumb.dataset.thumb;

      document.querySelectorAll('.product-gallery__slide').forEach(slide => {
        slide.classList.toggle('active', slide.dataset.slide === index);
      });

      document.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // --- Product gallery mobile scroll with dots ---
  const mobileScroll = document.querySelector('.product-gallery__mobile-scroll');
  const dots = document.querySelectorAll('.product-gallery__dot');
  if (mobileScroll && dots.length > 0) {
    const updateDots = () => {
      const scrollLeft = mobileScroll.scrollLeft;
      const itemWidth = mobileScroll.offsetWidth;
      const activeIndex = Math.round(scrollLeft / itemWidth);
      dots.forEach((dot, i) => dot.classList.toggle('active', i === activeIndex));
    };
    mobileScroll.addEventListener('scroll', updateDots, { passive: true });

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.dot);
        mobileScroll.scrollTo({ left: index * mobileScroll.offsetWidth, behavior: 'smooth' });
      });
    });
  }

  // --- Variant options ---
const variantData = [];
  document.querySelectorAll('[data-variant-select] option').forEach(opt => {
    variantData.push({
      id: opt.value,
      title: opt.textContent.trim(),
      price: opt.dataset.price || '',
      available: !opt.disabled,
      preorder: opt.dataset.preorder === 'true',
      qty: (opt.dataset.qty === '' || opt.dataset.qty == null) ? null : parseInt(opt.dataset.qty, 10)
    });
  });

  // --- Product quantity cap (block selecting more than available) ---
  const pqInput = document.querySelector('.product-info [data-quantity-input]');
  const pqMinus = pqInput ? pqInput.parentElement.querySelector('[data-quantity-minus]') : null;
  const pqPlus = pqInput ? pqInput.parentElement.querySelector('[data-quantity-plus]') : null;

  function clampQty() {
    if (!pqInput) return;
    let v = parseInt(pqInput.value, 10); if (isNaN(v) || v < 1) v = 1;
    const max = pqInput.getAttribute('max') ? parseInt(pqInput.getAttribute('max'), 10) : Infinity;
    if (v > max) v = max;
    pqInput.value = v;
    if (pqMinus) pqMinus.disabled = v <= 1;
    if (pqPlus) pqPlus.disabled = v >= max;
  }

  // cap = number (max units) or null (unlimited: made-to-order / untracked / continue)
  function applyQtyCap(cap) {
    if (!pqInput) return;
    if (cap == null || isNaN(cap)) {
      pqInput.removeAttribute('max');
    } else {
      pqInput.setAttribute('max', Math.max(1, cap));
    }
    clampQty();
  }

  if (pqInput) {
    pqInput.addEventListener('input', clampQty);
    pqInput.addEventListener('change', clampQty);
  }

  function updateVariant() {
    const selectedValues = [];
    document.querySelectorAll('.variant-selector__options').forEach(group => {
      const active = group.querySelector('.variant-option.selected');
      if (active) selectedValues.push(active.dataset.optionValue.trim());
    });

    const joined = selectedValues.join(' / ');
    const match = variantData.find(v => v.title === joined) || variantData.find(v => selectedValues.every(s => v.title.includes(s)));

    if (match) {
      const variantSelect = document.querySelector('[data-variant-select]');
      if (variantSelect) variantSelect.value = match.id;

      applyQtyCap(match.qty);

      const priceEl = document.querySelector('[data-product-price]');
      if (priceEl && match.price) priceEl.textContent = match.price;

      const submitBtn = document.querySelector('.product-form__submit');
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        if (submitBtn.dataset.madeToOrder === 'true') {
          const labelEl = submitBtn.querySelector('.product-form__submit-label');
          const isPre = match.available && match.preorder;
          const label = !match.available
            ? (submitBtn.dataset.soldOut || 'Sold out')
            : match.preorder
              ? (submitBtn.dataset.preorder || 'Pre-order')
              : (submitBtn.dataset.order || 'Order');
          if (labelEl) labelEl.textContent = label;
          submitBtn.classList.toggle('is-preorder', isPre);
          const leadEl = document.querySelector('[data-lead-time]');
          if (leadEl) {
            leadEl.textContent = leadEl.dataset.leadPreorder || '';
            leadEl.classList.toggle('is-preorder', isPre);
          }
        } else {
          submitBtn.textContent = match.available ? (submitBtn.dataset.addToCart || 'Add to bag') : (submitBtn.dataset.soldOut || 'Sold out');
        }
      }
    }
  }

  document.querySelectorAll('.variant-option').forEach(option => {
    option.addEventListener('click', () => {
      const siblings = option.parentElement.querySelectorAll('.variant-option');
      siblings.forEach(s => s.classList.remove('selected'));
      option.classList.add('selected');
      updateVariant();
    });
  });

  // Init quantity cap for the initially-selected variant (also covers single-variant products)
  (function initQtyCap() {
    const sel = document.querySelector('[data-variant-select]');
    if (!sel || !variantData.length) return;
    const m = variantData.find(v => v.id === sel.value) || variantData[0];
    if (m) applyQtyCap(m.qty);
  })();

  // --- Collection sort ---
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // --- Intersection Observer for fade-in animations ---
  if ('IntersectionObserver' in window) {
    const fadeObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.fade-in').forEach(el => fadeObserver.observe(el));
  }

});